var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FollowStatusTabs',{attrs:{"status":_vm.status}}),_c('FollowCards',_vm._g({attrs:{"followers":_vm.followers,"status":_vm.status}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }